import { SVG, IconProps } from "../SVG";
import React from "react";

export const GooglePay = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 13" {...props}>
        <g clipPath="url(#google_pay_svg__a)">
            <path
                fill="#fff"
                d="M17.607 0H6.373C2.863 0-.01 2.872-.01 6.383c0 3.51 2.873 6.383 6.383 6.383h11.234c3.51 0 6.383-2.872 6.383-6.383C23.99 2.873 21.118 0 17.607 0Z"
            />
            <path
                fill="#3C4043"
                d="M17.607.517a5.79 5.79 0 0 1 2.276.463 5.917 5.917 0 0 1 3.127 3.127 5.79 5.79 0 0 1 .463 2.276 5.79 5.79 0 0 1-.463 2.276 5.916 5.916 0 0 1-3.127 3.127 5.79 5.79 0 0 1-2.276.463H6.373a5.79 5.79 0 0 1-2.275-.463A5.916 5.916 0 0 1 .97 8.66a5.79 5.79 0 0 1-.463-2.276c0-.788.157-1.554.463-2.276A5.917 5.917 0 0 1 4.098.98 5.79 5.79 0 0 1 6.373.517h11.234Zm0-.517H6.373C2.863 0-.01 2.872-.01 6.383c0 3.51 2.873 6.383 6.383 6.383h11.234c3.51 0 6.383-2.872 6.383-6.383C23.99 2.873 21.118 0 17.607 0Z"
            />
            <path
                fill="#3C4043"
                d="M11.435 6.836v1.931h-.613V4h1.625c.411 0 .763.137 1.05.412.293.274.44.61.44 1.005 0 .405-.147.74-.44 1.012a1.463 1.463 0 0 1-1.05.405h-1.012v.003Zm0-2.25V6.25h1.024a.818.818 0 0 0 .607-.246.804.804 0 0 0 .246-.584.795.795 0 0 0-.246-.577.795.795 0 0 0-.607-.253h-1.024v-.003ZM15.539 5.396c.453 0 .81.122 1.072.364.262.243.392.575.392.996v2.01h-.584v-.452h-.025c-.252.373-.59.558-1.012.558-.36 0-.66-.105-.903-.32a1.019 1.019 0 0 1-.364-.797c0-.338.128-.606.383-.804.256-.201.597-.3 1.022-.3.363 0 .663.067.896.2v-.14a.696.696 0 0 0-.252-.542.865.865 0 0 0-.593-.224.931.931 0 0 0-.811.434l-.54-.338c.297-.43.738-.645 1.319-.645Zm-.792 2.369c0 .16.067.293.204.399a.75.75 0 0 0 .476.16.972.972 0 0 0 .69-.288.901.901 0 0 0 .302-.674c-.191-.15-.456-.226-.797-.226-.25 0-.457.06-.623.179-.169.124-.252.274-.252.45ZM20.336 5.502 18.293 10.2h-.631l.759-1.644-1.347-3.054h.667l.97 2.343h.013l.945-2.343h.667Z"
            />
            <path
                fill="#4285F4"
                d="M8.998 6.447c0-.2-.017-.391-.05-.575h-2.57v1.053h1.48c-.06.351-.253.65-.549.849v.683h.88c.515-.476.81-1.18.81-2.01Z"
            />
            <path
                fill="#34A853"
                d="M7.309 7.775c-.245.165-.56.262-.93.262-.713 0-1.318-.48-1.535-1.129h-.908v.705a2.734 2.734 0 0 0 2.443 1.506c.738 0 1.359-.243 1.81-.661l-.88-.683Z"
            />
            <path
                fill="#FABB05"
                d="M4.758 6.385c0-.182.03-.358.086-.523v-.705h-.909a2.72 2.72 0 0 0-.29 1.228c0 .442.105.859.29 1.228l.909-.705a1.649 1.649 0 0 1-.086-.523Z"
            />
            <path
                fill="#E94235"
                d="M6.379 4.733c.403 0 .764.14 1.049.41l.78-.78a2.627 2.627 0 0 0-1.83-.712 2.735 2.735 0 0 0-2.442 1.506l.908.705c.217-.648.822-1.129 1.535-1.129Z"
            />
        </g>
        <defs>
            <clipPath id="google_pay_svg__a">
                <path fill="#fff" d="M0 0h24v12.766H0z" />
            </clipPath>
        </defs>
    </SVG>
);
GooglePay.displayName = "GooglePay";
